import React, { Component } from 'react';

import { Icon, Upload, message } from 'antd';

import './Upload.css'

const Dragger = Upload.Dragger;

class UploadComponent extends Component {

  constructor(props) {
      super(props);
      this.handleFile = this.handleFile.bind(this);
      this.beforeUpload = this.beforeUpload.bind(this);
  }

  handleFile(file){
    this.props.handleFileUploaded(file);
  }

  beforeUpload(file) {
    if(this.props.type === 'illustration'){ 
      const isImage = (file.type === 'image/jpeg') || (file.type === 'image/jpg') || (file.type === 'image/png') || (file.type === 'image/gif');
      if (!isImage) {
        message.error('You can only upload image file!');
      }
      const isUnder3Mo = file.size / 1024 / 1024 < 4;
      if (!isUnder3Mo) {
        message.error('Image must smaller than 3Mo!');
      }
      return isImage && isUnder3Mo;
    }
  }

  render() {
    const token = localStorage.getItem('id_token');
    const headers = {
      "Authorization": "Bearer " + token
    }
    const handleFile = this.handleFile;
    const uploadObject = {
      name: 'file',
      multiple: true,
      data:{
        user_id: this.props.currentUser.email,
        project_id: this.props.data.project_id
      },
      action: process.env.REACT_APP_API_URL + '/upload',
      headers: headers,
      onChange(info) {
        const status = info.file.status;
        // if (status !== 'uploading') {
        //   console.log(info.file, info.fileList);
        // }
        if (status === 'done') {
          handleFile(info.file);
          message.success(`${info.file.name} a bien été uploadé.`);
        } else if (status === 'error') {
          message.error(`Le fichier ${info.file.name} n'a pas été uploadé.`);
        }
      }
    };

    return (
      <section>
        <Dragger {...uploadObject} beforeUpload={this.beforeUpload}>
          <p className="ant-upload-drag-icon">
            <Icon type="inbox" />
          </p>
          <p className="ant-upload-text">{this.props.message}</p>
        </Dragger>
      </section>
    );
  }
}

export default UploadComponent;


// WEBPACK FOOTER //
// ./src/components/Util/Upload.js